<template>
  <div :class="['sensors-cam-root', { 'sensors-cam-root--nav-card': navCard }]">
    <a class="card-button" @click="changeBarnTarget(barn, batch, sensors, hasIndividualWeighing ? '/batch-details/individual-weighing' : '/batch-details/smart-cam')">
      <div :title="hasIndividualWeighing ? 'Peso médio das baias, ponderado por quantidade de animais' : 'Dado mais recente da SmartCam'" :class="hasIndividualWeighing ? individualWeighingColor : smartCamColor">
        <div
          class="progress-bar progress"
          role="progressbar"
          :style="navCard ? undefined : 'width: 100%; padding: 0; margin: 0 2px; border-radius: 4px'"
        >
          <AnimadePlaceHolder v-if="loading" :height="navCard ? '72px' : '70px'" width="100%" :borderRadius="navCard ? '0' : '4px'"/>
          <div class="container-information-td feed-data-info-col" v-else>
            <div class="feed-data-name-container">
              <p class="product-information-line">
                <span>{{ hasIndividualWeighing ? individualWeighingText : smartCamText }}</span>
              </p>
              <p class="product-information-line" v-if="!hasIndividualWeighing && smartCamDate">
                <span>{{ smartCamDate }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
import { apiRoutes } from "../utils/api"
import AnimadePlaceHolder from './AnimadePlaceHolder.vue'
import { format, parseISO } from 'date-fns'
import { fmt, pct, deriveCorrales, deriveKpisGalpon } from "../utils/individual-weighing"
export default {
  name: "SensorsCam",
  components: {
    AnimadePlaceHolder
  },
  data() {
    return {
        loading: true
    }
  },
  props: ["sensors", "indexBarn", 'barn', 'batch', 'navCard'],
  methods: {
    async getDataCam() {
      if (this.sensors.length > 0) {
        for (const element of this.sensors) {
          try {
            this.$store.commit('incrementActiveRequests');
            let url_to_fetch = apiRoutes.smartCamHome(element.pk);
            const response = await fetch(url_to_fetch, {
                headers: this.$store.getters.getHeader
            });
            const json = await response.json();

            const allDataCam = {
              batch: this.batch[0],
              sensor: this.sensors,
              barn: this.barn,
              data: response.ok === false ? [] : [json]
            }
            this.$store.commit('setSensorsListCam', allDataCam)
          } finally { 
            this.loading = false
            this.$store.commit('decrementActiveRequests');
          }
        } 
      }
      //this.loading = false
      this.$store.commit('updateStateByBarn', {pk: this.barn?.pk, sensor: 'smartcam'})
    },
    changeBarnTarget(barn, batch, sensors, route) {

        this.$store.commit("setBarnTarget", barn)
        this.$store.commit("setBatchTarget", batch[0] == undefined ? null : batch[0])
        this.$router.push(route)

    },
    dateCompare: function(first_date, second_date) {
      return Math.ceil(Math.abs(new Date(second_date) - new Date(first_date)) / (1000 * 60 * 60 * 24));
    },
    formatDate(date) {
      if (!date) return null;
      try {
        return format(parseISO(date), 'dd-MM-yyyy');
      } catch {
        try {
          return format(new Date(date), 'dd-MM-yyyy');
        } catch {
          return null;
        }
      }
    },
  },
  computed: {
    companySettings() {
      return this.$store.getters.getCompanySettings
    },
    hasIndividualWeighing() {
      const cfg = this.companySettings?.settings?.client_frontend?.individual_weighing
      if (!cfg) return false
      if (cfg === true) return true
      const barns = cfg.barns || []
      return barns.includes(this.barn?.pk)
    },
    individualWeighingRaw() {
      return this.$store.getters.getCachedIndividualWeighingData(this.barn?.pk)
    },
    individualWeighingKpis() {
      if (!this.individualWeighingRaw) return null
      const corrales = deriveCorrales(this.individualWeighingRaw)
      return deriveKpisGalpon(this.individualWeighingRaw, corrales)
    },
    individualWeighingText() {
      if (!this.individualWeighingRaw) return "PESAGEM POR BAIA"
      if (!this.individualWeighingKpis) return "SEM PESO"
      if (this.individualWeighingKpis.vspic == null) return `${fmt(this.individualWeighingKpis.pesoMedio, 2)} kg`
      return `${fmt(this.individualWeighingKpis.pesoMedio, 1)} kg | ${pct(this.individualWeighingKpis.vspic)}`
    },
    individualWeighingColor() {
      const kpis = this.individualWeighingKpis
      if (!kpis || kpis.vspic == null) return 'individual-weighing progress'
      const percentage = (1 + kpis.vspic) * 100
      if (percentage > 105) return 'peso-atual-acima progress'
      if (percentage >= 100) return 'peso-atual-bom progress'
      if (percentage >= 95) return 'peso-atual-medio progress'
      return 'peso-atual-ruim progress'
    },
    smartCamDate() {
      if (this.dataCam.length === 0 || !this.batch[0] || this.batch[0].date_departure !== null) return null;
      const rawDate = this.dataCam[0]?.datetime_fetched
        || this.dataCam[0]?.datetime_last_ping
        || this.dataCam[0]?.date;
      return this.formatDate(rawDate);
    },
    smartCamText() {
      if (this.dataCam.length === 0) return "SEM DADOS"
      if (!this.batch[0]) return "SEM LOTE"
      if (this.batch[0].date_departure !== null) return "SEM LOTE"
      const weight = Math.round(this.dataCam[0].weight)
      return `${weight} kg | ${(this.percentage - 100).toFixed(1)}%`
    },
    percentage() {
      try {
        if (this.dataCam.length > 0 ) {
          return (this.dataCam[0].weight*100)/this.dataCam[0].reference_weight
        }
        else {
          return null
        }
      }
      catch(err) {
        return null
      }
    },
    smartCamColor() {
      if (this.smartCamText === "SEM CAM" || this.smartCamText === "EM BREVE") return 'no-sensor progress'
      if (this.smartCamText === "SEM LOTE")  return 'disable progress' 
      if (this.dataCam.length > 0) {
        const percentage = (Math.round(this.dataCam[0].weight)*100)/this.dataCam[0].reference_weight
        if (percentage > 105) {
          return 'peso-atual-acima progress'
        }
        if (percentage >= 100) {
          return 'peso-atual-bom progress'
        }
        if (percentage >= 95) {
          return 'peso-atual-medio progress'
        }
        if (percentage < 95) {
          return 'peso-atual-ruim progress'
        }
      }
      return 'disable progress'
    },
    getDataCamSave(){
      return this.$store.getters.getSensorsListCam
    },
    selectSensorCam() {
      if (this.$store.getters.getSensorsListCam.length > 0) {
        if (this.batch[0]) {
          return this.$store.getters.getSensorsListCam.find(obj => obj.batch?.pk == this.batch[0]?.pk)
        } else {
          return this.$store.getters.getSensorsListCam.find(obj => obj.barn?.pk == this.barn?.pk)
        }
      }
      return null
    },
    dataCam(){
      return this.selectSensorCam?.data ?? []
    },
  },
  async created() {
    if (this.hasIndividualWeighing) {
      const batch = Array.isArray(this.batch) ? this.batch[0] : this.batch
      await this.$store.dispatch('fetchIndividualWeighingData', {
        barnPk: this.barn?.pk,
        batchPk: batch?.pk ?? batch?.id ?? null,
        labels: { galpon: this.barn?.name || '' },
      })
      this.loading = false
      return
    }
    if (this.dataCam.length == 0) {
      await this.getDataCam()
      this.loading = false
    }
    this.loading = false
  }
};
</script>

<style scoped>
.cursor{
  cursor: not-allowed;
}

.progress {
  border-radius: 0;
  height: 70px;
  background-color: #f4f4f4;
  font-weight: bold;
  font-size: 14px;
}

.progress-bar {
  text-align: center;
  padding: 0;
}

a {text-decoration: none;}
.peso-atual-acima .progress-bar { background: #415430; color: #fff; }
a .peso-atual-acima .progress-bar:hover { background: #273619; }
.peso-atual-bom .progress-bar { background: #a1cd7b; color: #fff; }
a .peso-atual-bom .progress-bar:hover { background: #5e7d42; }
.peso-atual-medio .progress-bar { background: #e2bf65; color: #fff; }
a .peso-atual-medio .progress-bar:hover { background: #c59e3a; }
.peso-atual-ruim .progress-bar { background: #a94949; color: #fff; }
a .peso-atual-ruim .progress-bar:hover { background: #952323; }
.no-sensor .progress-bar { background: #f2f2f2; color: grey; }
a .no-sensor .progress-bar:hover { background: #cfcfcf; }
.disable .progress-bar { background: #adadad; color: #fff; }
a .disable .progress-bar:hover { background: grey; }
.individual-weighing .progress-bar { background: #1b4238; color: #fff; }
a .individual-weighing .progress-bar:hover { background: #78b843; }

.cam-data {
  transition: transform 0.3s cubic-bezier(0, 0, 0.2, 1); 

}

.cam-data:hover {
  animation: scaleAnimationCam 0.3s ease-in-out 25ms forwards; 
}

@keyframes scaleAnimationCam {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.3);

  }
}

.container-information-td.feed-data-info-col {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0;
}

.feed-data-name-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.product-information-line {
  margin: 0;
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  color: inherit;
  line-height: 1.5;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  text-align: center;
}

.product-information-line span {
  font-weight: 600;
  margin-left: 0;
}

.card-button {
  cursor: pointer;
}

.sensors-cam-root--nav-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.sensors-cam-root--nav-card .card-button {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 72px;
}

.sensors-cam-root--nav-card .card-button > div {
  flex: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.sensors-cam-root--nav-card .progress {
  flex: 1;
  width: 100%;
  min-height: 72px;
  height: 100%;
  border-radius: 0;
  margin: 0;
}

.sensors-cam-root--nav-card .progress-bar {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sensors-cam-root--nav-card .container-information-td {
  width: 100%;
  height: 100%;
}

.sensors-cam-root--nav-card .product-information-line {
  font-size: 14px;
  justify-content: center;
  text-align: center;
}
</style>
